var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_9393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88586 9C1.88586 8.58579 2.22164 8.25 2.63586 8.25L15.3638 8.25C15.778 8.25 16.1138 8.58579 16.1138 9C16.1138 9.41422 15.778 9.75 15.3638 9.75L2.63586 9.75C2.22164 9.75 1.88586 9.41421 1.88586 9Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99982 1.88604C8.5856 1.88604 8.24982 2.22183 8.24982 2.63604L8.24982 15.364C8.24982 15.7782 8.5856 16.114 8.99982 16.114C9.41403 16.114 9.74982 15.7782 9.74982 15.364L9.74982 2.63604C9.74982 2.22183 9.41403 1.88604 8.99982 1.88604Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_9393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.514648,
    y: 9,
    width: 12,
    height: 12,
    transform: "rotate(-45 0.514648 9)",
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.48ec13465d4a058ef860f259f5874ffb.svg";
export { ForwardRef as ReactComponent };